import { Component } from '@angular/core';

@Component({
  selector: 'blackout-dates',
  templateUrl: './blackout-dates.component.html',
  styleUrls: ['./blackout-dates.component.scss'],
})

export class BlackoutDatesComponent {}
